(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["printoni-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.ready) return;
    var pid=root.dataset.sectionId;
    var product;
    try{product=JSON.parse(root.dataset.product);}catch(error){root.hidden=true;return;}
    if(!product || !product.variants || !product.variants.length){root.hidden=true;return;}
    root.dataset.ready='true';
    var cfg={
      photo:root.dataset.photo==='true',
      photoRequired:root.dataset.photoRequired==='true',
      name:root.dataset.name==='true',
      nameRequired:root.dataset.nameRequired==='true',
      notes:root.dataset.notes==='true'
    };
    var currency=root.dataset.currency || 'USD';
    var locale=document.documentElement.lang || 'en-US';
    var route=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var initialId=Number(root.dataset.initialId);
    var initial=product.variants.find(function(v){return v.id===initialId;}) || product.variants[0];
    var onlyDefault=product.variants.length===1 && product.variants[0].title==='Default Title';
    var tiers=Array.from(root.querySelectorAll('.pb-tier'));
    var btn=root.querySelector('[data-atc]');
    var status=root.querySelector('[data-status]');
    var busy=false;
    var urls=new Set();
    function money(cents){return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(cents/100);}
    function message(text){status.textContent=text;status.hidden=!text;}
    function field(row,label,type,n,oi){
      var holder=document.createElement('label');holder.className='pb-field';
      var title=document.createElement('span');title.className='pb-field-label';title.textContent=label;
      var input=document.createElement(type==='textarea'?'textarea':type==='select'?'select':'input');
      if(type!=='textarea' && type!=='select') input.type=type;
      input.id='pb-'+pid+'-'+row.dataset.tier+'-'+n+'-'+oi;
      holder.htmlFor=input.id;holder.append(title,input);row.appendChild(holder);return input;
    }
    function build(tier,ti){
      var total=Number(tier.dataset.paid)+Number(tier.dataset.free);
      var wrap=tier.querySelector('[data-items]');
      for(var n=1;n<=total;n++){
        var row=document.createElement('fieldset');row.className='pb-item';row.dataset.tier=ti;row.dataset.item=n;
        var legend=document.createElement('legend');legend.textContent='Item #'+n;row.appendChild(legend);
        if(!onlyDefault){
          var options=document.createElement('div');options.className='pb-options';options.dataset.tier=ti;row.appendChild(options);
          product.options.forEach(function(opt,oi){
            var label=typeof opt==='string'?opt:opt.name;
            var select=field(options,label,'select',n,'option-'+oi);select.dataset.option=oi;
            var values=Array.from(new Set(product.variants.map(function(v){return v['option'+(oi+1)];})));
            values.forEach(function(value){var option=document.createElement('option');option.value=value;option.textContent=value;select.appendChild(option);});
            select.value=initial['option'+(oi+1)];select.addEventListener('change',updatePrices);
          });
        }
        if(cfg.photo){
          var photo=field(row,"Upload your pet's photo"+(cfg.photoRequired?' *':''),'file',n,'photo');
          photo.dataset.photo='';photo.accept='image/jpeg,image/png,image/webp';photo.required=cfg.photoRequired;
          var help=document.createElement('small');help.className='pb-help';help.textContent='JPG, PNG or WebP. Maximum 10 MB. Choose a separate photo for this item.';row.appendChild(help);
          var preview=document.createElement('img');preview.className='pb-photo-preview';preview.hidden=true;preview.alt='Selected pet photo';row.appendChild(preview);
          photo.addEventListener('change',function(){
            var image=this.closest('.pb-item').querySelector('.pb-photo-preview');
            if(image.dataset.url){URL.revokeObjectURL(image.dataset.url);urls.delete(image.dataset.url);}
            image.hidden=true;image.removeAttribute('src');delete image.dataset.url;
            var file=this.files[0];this.setCustomValidity('');
            if(!file) return;
            if(!['image/jpeg','image/png','image/webp'].includes(file.type)){this.setCustomValidity('Please choose a JPG, PNG or WebP image.');this.reportValidity();return;}
            if(file.size>10*1024*1024){this.setCustomValidity('Please choose an image smaller than 10 MB.');this.reportValidity();return;}
            var url=URL.createObjectURL(file);urls.add(url);image.dataset.url=url;image.src=url;image.hidden=false;
          });
        }
        if(cfg.name){var name=field(row,"Your pet's name"+(cfg.nameRequired?' *':''),'text',n,'name');name.dataset.petName='';name.required=cfg.nameRequired;name.maxLength=100;}
        if(cfg.notes){var notes=field(row,'Special notes (optional)','textarea',n,'notes');notes.dataset.notes='';notes.maxLength=1000;}
        wrap.appendChild(row);
      }
    }
    function variant(row){
      if(onlyDefault) return product.variants[0];
      var values=Array.from(row.querySelectorAll('[data-option]')).map(function(s){return s.value;});
      return product.variants.find(function(v){return values.every(function(value,i){return v['option'+(i+1)]===value;});});
    }
    function updatePrices(){
      tiers.forEach(function(tier){
        var variants=Array.from(tier.querySelectorAll('.pb-item')).map(variant);
        var valid=variants.every(function(v){return v && v.available;});
        if(!valid){tier.querySelector('[data-now]').textContent='Unavailable';['[data-was]','[data-save]','[data-each]'].forEach(function(s){tier.querySelector(s).textContent='';});return;}
        var total=variants.reduce(function(sum,v){return sum+v.price;},0);
        var prices=variants.map(function(v){return v.price;}).sort(function(a,b){return a-b;});
        var free=prices.slice(0,Number(tier.dataset.free)).reduce(function(sum,p){return sum+p;},0);
        var pay=Math.round((total-free)*(1-Number(tier.dataset.pct)/100));
        var save=total?Math.round((total-pay)/total*100):0;
        tier.querySelector('[data-now]').textContent=money(pay);
        tier.querySelector('[data-was]').textContent=save>0?money(total):'';
        tier.querySelector('[data-save]').textContent=save>0?'SAVE '+save+'%':'';
        tier.querySelector('[data-each]').textContent=variants.length>1?money(pay/variants.length)+' each':'';
      });
    }
    function activate(tier){
      if(busy)return;
      tiers.forEach(function(t){var active=t===tier;t.classList.toggle('is-active',active);var head=t.querySelector('.pb-tier-head');head.setAttribute('aria-checked',String(active));head.tabIndex=active?0:-1;});
      message('');
    }
    tiers.forEach(function(tier,i){
      build(tier,i);
      var head=tier.querySelector('.pb-tier-head');head.addEventListener('click',function(){activate(tier);});
      head.addEventListener('keydown',function(e){
        if(!['ArrowDown','ArrowUp','ArrowLeft','ArrowRight','Home','End'].includes(e.key) || busy)return;
        e.preventDefault();var index=e.key==='Home'?0:e.key==='End'?tiers.length-1:(i+(['ArrowDown','ArrowRight'].includes(e.key)?1:-1)+tiers.length)%tiers.length;
        activate(tiers[index]);tiers[index].querySelector('.pb-tier-head').focus();
      });
    });
    updatePrices();
    async function request(endpoint,data){
      var response=await fetch(route+endpoint,{method:'POST',body:data,headers:{Accept:'application/json'}});
      var result=await response.json();
      if(!response.ok) throw new Error(result.description || result.message || 'Could not add this item.');
      return result;
    }
    btn.addEventListener('click',async function(){
      if(busy)return;
      var active=root.querySelector('.pb-tier.is-active');if(!active)return;
      var rows=Array.from(active.querySelectorAll('.pb-item'));
      for(var row of rows){
        var selected=variant(row);
        if(!selected || !selected.available){message('Please choose an available option for item #'+row.dataset.item+'.');return;}
        var pet=row.querySelector('[data-pet-name]');if(pet){pet.value=pet.value.trim();}
        for(var input of row.querySelectorAll('input,textarea,select')){if(!input.reportValidity()){message('Please complete the required details for item #'+row.dataset.item+'.');return;}}
      }
      busy=true;btn.disabled=true;root.setAttribute('aria-busy','true');
      var label=btn.textContent;btn.textContent='Adding your bundle…';message('');
      root.querySelectorAll('input,textarea,select,.pb-tier-head').forEach(function(el){el.disabled=true;});
      var token=window.crypto && window.crypto.randomUUID?window.crypto.randomUUID():Date.now()+'-'+Math.random().toString(36).slice(2);
      try{
        for(var index=0;index<rows.length;index++){
          var row=rows[index];var data=new FormData();data.append('id',String(variant(row).id));data.append('quantity','1');
          data.append('properties[_printoni_bundle]',token);data.append('properties[Bundle item]',String(index+1)+' of '+rows.length);
          var pet=row.querySelector('[data-pet-name]');var notes=row.querySelector('[data-notes]');var photo=row.querySelector('[data-photo]');
          if(pet && pet.value.trim())data.append("properties[Your pet's name]",pet.value.trim());
          if(notes && notes.value.trim())data.append('properties[Special notes (optional)]',notes.value.trim());
          if(photo && photo.files[0])data.append("properties[Upload your pet's photo]",photo.files[0],photo.files[0].name);
          await request('cart/add.js',data);
        }
        // Check persisted cart properties, including a server-hosted photo URL.
        var cartResponse=await fetch(route+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error('Could not verify your bundle. Please try again.');
        var cart=await cartResponse.json();
        var saved=cart.items.filter(function(item){return item.properties && item.properties._printoni_bundle===token;});
        if(saved.length!==rows.length)throw new Error('Could not verify all items in your bundle.');
        rows.forEach(function(row,i){
          var item=saved.find(function(item){return item.properties['Bundle item']===String(i+1)+' of '+rows.length;});
          var photo=row.querySelector('[data-photo]');var pet=row.querySelector('[data-pet-name]');var notes=row.querySelector('[data-notes]');
          if(!item || item.quantity!==1 || String(item.variant_id)!==String(variant(row).id))throw new Error('Could not verify item #'+(i+1)+'.');
          if(pet && pet.value.trim() && item.properties["Your pet's name"]!==pet.value.trim())throw new Error('Could not save the pet name for item #'+(i+1)+'.');
          if(notes && notes.value.trim() && item.properties['Special notes (optional)']!==notes.value.trim())throw new Error('Could not save the notes for item #'+(i+1)+'.');
          if(photo && photo.files[0]){
            var url=item.properties["Upload your pet's photo"];
            if(typeof url!=='string' || !/^(https?:\/\/|\/\/|\/(?!\/))/.test(url))throw new Error('Could not save the photo for item #'+(i+1)+'.');
          }
        });
        window.location.assign(route+'cart');
      }catch(error){
        // Remove only lines created by this attempt; preserve earlier cart items.
        var cleaned=false;
        try{
          var response=await fetch(route+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)throw new Error('Cart unavailable');
          var cart=await response.json();var lines=cart.items.filter(function(item){return item.properties && item.properties._printoni_bundle===token;});
          for(var item of lines){var remove=new FormData();remove.append('id',item.key);remove.append('quantity','0');await request('cart/change.js',remove);}
          cleaned=true;
        }catch(cleanupError){}
        message((error.message || 'Could not add your bundle.')+(cleaned?' Please try again.':' Some items may have been added. Open your cart and remove those bundle items before trying again.'));
        if(!cleaned){var link=document.createElement('a');link.href=route+'cart';link.textContent=' Open cart';status.appendChild(link);}
        if(cleaned){busy=false;btn.disabled=false;root.removeAttribute('aria-busy');btn.textContent=label;root.querySelectorAll('input,textarea,select,.pb-tier-head').forEach(function(el){el.disabled=false;});}
        else{btn.textContent='Check your cart before retrying';root.removeAttribute('aria-busy');}
      }
    });
    document.addEventListener('shopify:section:unload',function(e){if(e.detail && e.detail.sectionId===pid){urls.forEach(function(url){URL.revokeObjectURL(url);});}});
  }
  function initAll(scope){
    if(scope.matches && scope.matches('[data-printoni-bundle]'))init(scope);
    scope.querySelectorAll('[data-printoni-bundle]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});
  else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
